import { timeFormat } from "d3";
import { gatewayService } from "@/_services/gateway.service";

export function downloadDataModelTable(_this) {
  let formatTime = timeFormat("%Y-%m-%d");
  var filename =
    _this.companies[_this.selectedCompany].company_name.replace(/ /g, "_") +
    "_" +
    formatTime(new Date())
  gatewayService.user
    .downloadDataModelFile({ origin: _this.selection, filename: filename })
    .then(data => {
      var contentType = "application/vnd.ms-excel.sheet.macroEnabled.12";
      var formatTime = timeFormat("%Y-%m-%d");
      var filename =
        _this.companies[_this.selectedCompany].company_name.replace(/ /g, "_") +
        "_" +
        formatTime(new Date()) + ".xlsm";

      var blob = new Blob([data], { type: contentType });

      var downloadUrl = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      _this.modal_processing_message.showModalLoading = false;
    })
    .catch(error => {
      _this.modal_processing_message.showModalLoading = false;
      console.error("Error downloading data-model table", error);
    });
}
